import { InjectionToken } from '@angular/core';

import Settings from '../builder/instructions/settings/settings';

import { CityRepositoryInterface } from './city/interfaces/repositories/city.repository.interface';
import { AuthRepositoryInterface } from './auth/interfaces/repositories/auth.repository.interface';
import { UserRepositoryInterface } from './user/interfaces/repositories/user.repository.interface';
import { TwoFactorAuthenticationRepositoryInterface } from './two-factor/interfaces/repositories/two-facto-authentication.repository.interface';
import { CertificateRepositoryInterface } from './certificate/interfaces/repositories/certificate.repository.interface';
import { SearchCepProviderInterface } from './city/interfaces/providers/search-cep.provider.interface';
import { SearchCnpjProviderInterface } from './company/interfaces/providers/search-cnpj.provider.interface';
import { GetCityByIdentityServiceInterface } from './city/interfaces/services/get-city-by-identity.service.interface';
import { LoginByFormServiceInterface } from './auth/interfaces/services/login-by-form.service.interface';
import { LoginByIntegrationServiceInterface } from './auth/interfaces/services/login-by-integration.service.interface';
import { RecoverPasswordServiceInterface } from './auth/interfaces/services/recover-password.service.interface';
import { ResetPasswordServiceInterface } from './auth/interfaces/services/reset-password.service.interface';
import { ResendAccountConfirmationServiceInterface } from './auth/interfaces/services/resend-account-confirmation.service.interface';
import { VerifyChangePasswordTokenService } from './auth/services/verify-change-password-token.service';
import { VerifyUserPasswordService } from './auth/services/verify-user-password.service';
import { CreateAccountServiceInterface } from './user/interfaces/services/create-account.service.interface';
import { UpdateAccountServiceInterface } from './user/interfaces/services/update-account.service.interface';
import { ValidateCpfEmailServiceInterface } from './user/interfaces/services/validate-cpf-email.service.interface';
import { TwoFactorAuthenticationServiceInterface } from './two-factor/interfaces/services/two-factor-authentication.service.interface';
import { ValidateCertificateAuthenticationServiceInterface } from './certificate/interfaces/services/validate-certificate-authentication.service.interface';
import { VerifyCreateAccountTokenServiceInterface } from './auth/interfaces/services/verify-create-account-token.service.interface';
import { UseAuthorizationCodeServiceInterface } from './auth/interfaces/services/use-authorization-code.service.interface';
import { GetPylonCitiesServiceInterface } from './auth/interfaces/services/get-pylon-cities.service.interface';
import { ValidateAccountConfirmationServiceInterface } from './auth/interfaces/services/validate-account-confirmation.service.interface';
import { WebPkiAdapter } from '../infrastructure/adapters/web-pki.adapter';
import { RepresentativeRepositoryInterface } from './representative/interfaces/repositories/representative.repository.interface';
import { ValidateRfServiceInterface } from './representative/interfaces/services/validate-rf.service.interface';
import { UploadDocumentServiceInterface } from './representative/interfaces/services/upload-document.service.interface';

const Types = {
  Settings: new InjectionToken<Settings>('Settings'),
  CityRepository: new InjectionToken<CityRepositoryInterface>('CityRepository'),
  AuthRepository: new InjectionToken<AuthRepositoryInterface>('AuthRepository'),
  UserRepository: new InjectionToken<UserRepositoryInterface>('UserRepository'),
  TwoFactorAuthenticationRepository:
    new InjectionToken<TwoFactorAuthenticationRepositoryInterface>(
      'TwoFactorAuthenticationRepository'
    ),
  CertificateRepository: new InjectionToken<CertificateRepositoryInterface>(
    'CertificateRepository'
  ),
  SearchCepProvider: new InjectionToken<SearchCepProviderInterface>(
    'SearchCepProvider'
  ),
  SearchCnpjProvider: new InjectionToken<SearchCnpjProviderInterface>(
    'SearchCnpjProvider'
  ),
  GetCityByIdentityService:
    new InjectionToken<GetCityByIdentityServiceInterface>(
      'GetCityByIdentityService'
    ),
  LoginByFormService: new InjectionToken<LoginByFormServiceInterface>(
    'LoginByFormService'
  ),
  LoginByIntegrationService:
    new InjectionToken<LoginByIntegrationServiceInterface>(
      'LoginByIntegrationService'
    ),
  RecoverPasswordService: new InjectionToken<RecoverPasswordServiceInterface>(
    'RecoverPasswordService'
  ),
  ResetPasswordService: new InjectionToken<ResetPasswordServiceInterface>(
    'ResetPasswordService'
  ),
  VerifyChangePasswordTokenService:
    new InjectionToken<VerifyChangePasswordTokenService>(
      'VerifyChangePasswordTokenService'
    ),
  VerifyUserPasswordService: new InjectionToken<VerifyUserPasswordService>(
    'VerifyUserPasswordService'
  ),
  ResendAccountConfirmationService:
    new InjectionToken<ResendAccountConfirmationServiceInterface>(
      'ResendAccountConfirmationService'
    ),
  ValidateAccountConfirmationService:
    new InjectionToken<ValidateAccountConfirmationServiceInterface>(
      'ValidateAccountConfirmationService'
    ),
  CreateAccountService: new InjectionToken<CreateAccountServiceInterface>(
    'CreateAccountService'
  ),
  UpdateAccountService: new InjectionToken<UpdateAccountServiceInterface>(
    'UpdateAccountService'
  ),
  ValidateCpfEmailService: new InjectionToken<ValidateCpfEmailServiceInterface>(
    'ValidateCpfEmailService'
  ),
  TwoFactorAuthenticationService:
    new InjectionToken<TwoFactorAuthenticationServiceInterface>(
      'TwoFactorAuthenticationService'
    ),
  ValidateCertificateAuthenticationService:
    new InjectionToken<ValidateCertificateAuthenticationServiceInterface>(
      'ValidateCertificateAuthenticationService'
    ),
  VerifyCreateAccountTokenService:
    new InjectionToken<VerifyCreateAccountTokenServiceInterface>(
      'VerifyCreateAccountTokenService'
    ),
  UseAuthorizationCodeService:
    new InjectionToken<UseAuthorizationCodeServiceInterface>(
      'UseAuthorizationCodeService'
    ),
  GetPylonCitiesService: new InjectionToken<GetPylonCitiesServiceInterface>(
    'GetPylonCitiesService'
  ),
  WebPkiAdapter: new InjectionToken<WebPkiAdapter>('WebPkiAdapter'),
  RepresentativeRepository: new InjectionToken<RepresentativeRepositoryInterface>(
    'RepresentativeRepository'
  ),
  ValidateRfService: new InjectionToken<ValidateRfServiceInterface>(
    'ValidateRfService'
  ),
  UploadDocumentService: new InjectionToken<UploadDocumentServiceInterface>(
    'UploadDocumentService'
  ),
};

export { Types };
